//jQuery(document).ready(function($) {
//    if(!is_dev) {
//        return;
//    }
//    add_document({"reload_item":".documents-table","contact_id":"3097"});
//});
function add_document(vars) {
    const $ = jQuery.noConflict();
    const saveable_ids = ['contact_id', 'company_id', 'appointment_id', 'inspectionContract_id'];

    let is_orphan = vars === undefined;
    if(!is_orphan) {
        is_orphan = true;
        saveable_ids.forEach(function(key) {
            if(vars[key] !== undefined) {
                is_orphan = false;
            }
        })
    }

    if(is_orphan) {
        alert('Cannot add document for it would be an orphan');
        return false;
    }

    $.squdeAjaxPopup({
        url: '/documents/add',
        onOpen: function (elm, popup) {
            console.log({type: vars !== undefined ? vars.document_type_id : undefined});
            elm.find('[data-document-type-selector]').documentTypeSelector(vars !== undefined ? vars.document_type_id : undefined);

            elm.find('.custom-file-uploader')[0].onload = function(input) {
                input.bind('change.once', function() {
                    $(this).unbind('change.once');
                    elm.find('.file-details-wrapper').toggleNiceShow();
                });
                input.bind('change.always', function() {
                    var fReader = new FileReader();
                    var file = $(this)[0].files[0];
                    //console.log(file);
                    elm.find('input[name="name"]').val(file.name);
                    elm.find('input[name="show_size"]').val((Math.round((file.size / 1000 / 1000) * 100) / 100) + ' MB');
                    elm.find('input[name="size"]').val(file.size);
                    elm.find('input[name="mime_type"]').val(file.type);
                });
            };

            saveable_ids.forEach(function(keyname) {
                if(vars[keyname] != undefined) {
                    elm.find('input[name="mime_type"]').after('<input type="hidden" name="'+keyname+'" value="'+vars[keyname]+'" />');
                }
            });

            elm.find('form').ajaxFormSubmit(function(data, last_form){
                elm.doneLoading();
                //$('.documents-table').reloadThisElement();
                reload_location_if_needed();

            }.bind([elm,popup]), function(xhr, status, error) {
                elm.doneLoading();
                console.log([status,error]);
            }.bind([elm,popup]), function() {
                elm.isLoading();
            });
        }
    });
    return false;
}
function delete_document(id, name) {
    var $ = jQuery.noConflict();
    name = decodeURI(name);

    confirm("Weet u zeker dat u \""+name+"\" wilt verwijderen?", function() {
        $('body').isLoading('dark');
        $.ajax({
            url: "/documents/delete",
            data: {id:id},
            type: "POST",
            success: function(data) {
                $('.documents-table').reloadThisElement();
                $('body').doneLoading();
            },
            error: function(e) {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });
    });
    return false;
}
function toggle_external(sender) {
    var $ = jQuery.noConflict();
    var elm = $(sender);
    var id = parseInt(elm.parents('tr[data-id]').attr('data-id'));
    $('body').isLoading('dark');

    $.post('/documents/setExternal', {id: id, external: (elm.is(':checked') ? 1 : 0)}, function(data) {
        //reload_location_if_needed();
        $('body').doneLoading();
    });
    return false;
}
function send_document(id) {
    const $ = jQuery.noConflict();
    $.squdeAjaxPopup({
        url: '/documents/send/' + id,
        onOpen: function (elm, popup) {
            initiate_default_message_selector(elm);


            elm.find('form').ajaxFormSubmit(function(data, last_form){
                elm.doneLoading();
                reload_location_if_needed();

            }.bind([elm,popup]), function(xhr, status, error) {
                elm.doneLoading();
                console.log([status,error]);
            }.bind([elm,popup]), function() {
                elm.isLoading();
            });
        }
    });
    return false;
}
function view_document(id) {
    const $ = jQuery.noConflict();
    $.squdeAjaxPopup({
        url: '/documents/view/' + id,
        onOpen: function (elm, popup) {
            elm.find('[data-document-type-selector]').documentTypeSelector();


            elm.find('form').ajaxFormSubmit(function(data, last_form){
                elm.doneLoading();
                reload_location_if_needed();

            }.bind([elm,popup]), function(xhr, status, error) {
                elm.doneLoading();
            }.bind([elm,popup]), function() {
                elm.isLoading();
            });
        }
    });
    return false;
}
function init_documents_filters(elm) {
    elm.find('.documents-table').unbind('onReload').bind('onReload', reload_datepickers);
}